"use client";

import { useConsultation } from "../../../../context/ConsultationContext";
import { useAuth } from "../../../../context/AuthContext";
import styles from "../css/consultation-header.module.css";

export default function ConsultationHeader({ 
  currentStep, 
  totalSteps, 
  onPrevious, 
  onNext, 
  variant = "patient-overview",
  stepTitle,
  stepDetails,
  nextLabel = "Next",
  showNextDropdown = false
}) {
  const { consultationData } = useConsultation();
  const { user } = useAuth();
  const patient = consultationData?.patient || {};
  const serviceName =
    consultationData?.serviceName ||
    consultationData?.service?.servicename ||
    consultationData?.service?.name ||
    "";
  const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim();
  
  const initials = `${patient.firstname?.[0] || ""}${patient.surname?.[0] || ""}`.toUpperCase();

  const storedUser = (() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();
  const userObj = user || storedUser || {};
  const roleId = Number(userObj?.roleid);
  const roleName = String(userObj?.rolename || "").trim().toLowerCase();
  const isNurse = roleId === 6 || roleName === "nurse";
  const nurseStepIds = [1, 2, 3, 4, 5, 7, 10];

  const displayTotalSteps = isNurse ? nurseStepIds.length : totalSteps;
  const displayStepNumber = (() => {
    if (!isNurse) return currentStep;
    const idx = nurseStepIds.indexOf(currentStep);
    return idx >= 0 ? idx + 1 : currentStep;
  })();

  const extraDetails = (() => {
    const raw = String(stepDetails || "").trim();
    if (!raw) return "";
    if (raw.includes("·")) return "";
    return raw;
  })();

  const detailsLine = [
    `Step ${displayStepNumber} of ${displayTotalSteps}`,
    patientName,
    serviceName,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <div className={`${styles.headerCard} ${styles[variant]}`}>
      {/* Left Side - Patient Info (only for step 1) */}
      {currentStep === 1 && (
        <div className={styles.headerLeft}>
          <div className={styles.avatar}>{initials || ""}</div>
          <div className={styles.patientInfo}>
            <div className={styles.nameRow}>
              <h2 className={styles.patientName}>
                {patientName}
              </h2>
            </div>
            <p className={styles.profileNumber}>
              <span>Profile: {patient.profilenumber || ""}</span>
              <span className={styles.badge}>Dependent</span>
            </p>
          </div>
        </div>
      )}

      {/* Left Side - Step Info (for steps 2-10) */}
      {currentStep !== 1 && variant === "step" && (
        <div className={styles.stepHeaderContent}>
          <h2 className={styles.stepTitle}>{stepTitle}</h2>
          <p className={styles.stepDetails}>
            {detailsLine}{extraDetails ? ` - ${extraDetails}` : ""}
          </p>
        </div>
      )}

      {/* Right Side - Navigation */}
      <div className={styles.headerRight}>
        <div className={styles.navButtons}>
          <button 
            className={styles.prevBtn} 
            onClick={onPrevious} 
            disabled={!onPrevious}
          >
            ‹ Previous
          </button>
          {showNextDropdown ? (
            <button 
              className={`${styles.nextBtn} ${styles.invoiceBtn}`} 
              onClick={onNext} 
              disabled={!onNext}
            >
              {nextLabel} <span className={styles.checkmark}>✓</span>
            </button>
          ) : (
            <button 
              className={styles.nextBtn} 
              onClick={onNext} 
              disabled={!onNext}
            >
              {nextLabel} ›
            </button>
          )}
        </div>
        {variant === "patient-overview" && (
          <span className={styles.stepIndicator}>
            Step {displayStepNumber} of {displayTotalSteps}
          </span>
        )}
      </div>
    </div>
  );
}
